export function checkRule(reObject) {
  if (typeof reObject != 'object') {
    return false
  }
  const { re, replacement } = reObject
  const hasRe = re instanceof RegExp
  const type = ['string', 'function'].indexOf(typeof replacement) != -1
  return hasRe && type
}

export const hideStack = (commonError, thrownError) => {
  if (!(thrownError instanceof Error)) throw thrownError
  const [, , commonLine] = commonError.stack.split('\n', 3)
  const i = thrownError.stack.indexOf(commonLine)
  if (i == -1) throw thrownError
  const stack = thrownError.stack.substr(0, i - 1)
  const li = stack.lastIndexOf('\n')
  thrownError.stack = stack.substr(0, li)
  throw thrownError
}